import { useQuery } from '@tanstack/react-query';
import { ChangeEvent, useState } from 'react';
import { Link } from 'react-router-dom';

import { getFactoryCodeList } from 'api/deviceApi';
import { factoryCodeKeys } from 'api/quires/queryKeys';
import Image from 'components/widget/Image';

import HeaderNavList from './HeaderNavList';
import pen from './pen.svg';

type HeaderInfoProps = {
  name: string;
  onClick: () => void;
  onChange: (factoryCode: string) => void;
  factoryCode: string;
};

export default function HeaderInfo({
  name,
  onClick,
  onChange,
  factoryCode,
}: HeaderInfoProps) {
  const { data: factoryCodeResp } = useQuery(
    factoryCodeKeys.all,
    getFactoryCodeList,
  );

  const [factory, setFactory] = useState(factoryCode ?? 'ALL');
  const onChangeFactoryCode = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    setFactory(value);
    onChange(value);
  };

  return (
    <div id={'header'}>
      <div id={'logo'}>
        <Link to={'/home/status-board'}>{'LOTO'}</Link>
      </div>
      <div className={'gnb-wrap'}>
        <HeaderNavList />
      </div>
      <div className={'account-wrap'}>
        <div className={'select-wrap'}>
          <select
            className={'factoryCode-wrap'}
            value={factory}
            onChange={onChangeFactoryCode}
          >
            <option value={'ALL'}>{'전체'}</option>
            {factoryCodeResp?.list?.map((facCode) => (
              <option value={facCode.codeName} key={facCode.factoryCode}>
                {facCode.codeName}
              </option>
            ))}
          </select>
        </div>
        <p className={'membername'}>
          <span className={'grade'} />
          <Link to={'mypage'}>
            {`${name} 님`}
            &nbsp;
            <Image
              src={pen}
              alt={'mypage'}
              width={20}
              height={20}
              className={'img-top'}
            />
          </Link>
        </p>
        <button type={'button'} className={'btn-login'} onClick={onClick}>
          {'로그아웃'}
        </button>
      </div>
    </div>
  );
}
